// extracted by mini-css-extract-plugin
module.exports = {"container":"VotingGovernment_container__2B72R","title":"VotingGovernment_title__1Wjr9","description":"VotingGovernment_description__2CqAd"};